// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* imported from Search.module.scss 
   */
.Search-module-Root_1Dk {
  display: inline-flex;
  align-items: center;
  box-sizing: border-box;
  width: 100%;
  min-height: 48px;
  padding: 4px 8px;
  border-radius: 200px;
  background-color: var(--search-background-color-normal); }

.Search-module-Label_1K1 {
  display: inline-flex;
  flex-grow: 1;
  align-self: stretch;
  padding-right: 8px; }
  .Search-module-Label_1K1:last-child {
    padding-right: 12px; }

.Search-module-Control_1Ei {
  flex-grow: 1;
  box-sizing: border-box;
  /**
   * По умолчанию инпут имеет определенную ширину.
   * Из-за этого соседние элементы могут сжиматься при нехватке места в контейнере.
   * Нулевая ширина перекрывается свойством flex-grow. Инпут займет всю свободную площадь не ущемляя соседей.
   */
  width: 0;
  padding-left: 8px; }
  .Search-module-Control_1Ei:first-child {
    padding-left: 12px; }

.Search-module-pressed_JrS {
  background-color: var(--search-background-color-pressed); }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Search/Search.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;IACI;AACJ;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,uDAAuD,EAAE;;AAE3D;EACE,oBAAoB;EACpB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB,EAAE;EACpB;IACE,mBAAmB,EAAE;;AAEzB;EACE,YAAY;EACZ,sBAAsB;EACtB;;;;IAIE;EACF,QAAQ;EACR,iBAAiB,EAAE;EACnB;IACE,kBAAkB,EAAE;;AAExB;EACE,wDAAwD,EAAE","sourcesContent":["@charset \"UTF-8\";\n/* imported from Search.module.scss \n   */\n.Search-module-Root_1Dk {\n  display: inline-flex;\n  align-items: center;\n  box-sizing: border-box;\n  width: 100%;\n  min-height: 48px;\n  padding: 4px 8px;\n  border-radius: 200px;\n  background-color: var(--search-background-color-normal); }\n\n.Search-module-Label_1K1 {\n  display: inline-flex;\n  flex-grow: 1;\n  align-self: stretch;\n  padding-right: 8px; }\n  .Search-module-Label_1K1:last-child {\n    padding-right: 12px; }\n\n.Search-module-Control_1Ei {\n  flex-grow: 1;\n  box-sizing: border-box;\n  /**\n   * По умолчанию инпут имеет определенную ширину.\n   * Из-за этого соседние элементы могут сжиматься при нехватке места в контейнере.\n   * Нулевая ширина перекрывается свойством flex-grow. Инпут займет всю свободную площадь не ущемляя соседей.\n   */\n  width: 0;\n  padding-left: 8px; }\n  .Search-module-Control_1Ei:first-child {\n    padding-left: 12px; }\n\n.Search-module-pressed_JrS {\n  background-color: var(--search-background-color-pressed); }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
